(function (root) {
  'use strict';
  const weights = [1.3, 0.9, 1.4, 1, 1.2];
  const initial = [[5,3,4,3,4], [3,2,5,5,4], [3,4,4,4,5]];
  const flavorWeights = [[1,.2,0,0,0,0,0], [.1,.8,1,.3,.2,0,0], [0,0,0,1,.8,.3,0], [0,0,0,0,0,.1,1]];
  const structurePending = ['blend-back-2-back-ブレンド-バックトゥバック'];
  // User-approved recommendation v1 values. Not absolute cupping scores.
  const flavors = {
    'blend-back-2-back-ブレンド-バックトゥバック': [0,0,0,0,0,0,5],
    'seasonal-blend-underground-remix': [1,0,4,0,0,3,3],
    'colombia-el-diviso-pink-bourbon': [0,5,0,0,0,0,1],
    'colombia-el-diviso-ombligon': [0,0,0,5,1,1,4],
    'colombia-el-diviso-typica-mejorado': [0,0,5,4,0,0,3],
    'colombia-sudan-rume-buenos-aires': [0,0,1,5,0,0,1],
    'ethiopia-tamiru-tadesse-alo-mosto': [3,0,5,0,4,2,1],
    'ethiopia-nigusse-gemeda-morke': [4,0,0,0,0,0,1],
    'honduras-marysabel-caballero-y-moises-geisha-fully-washed': [5,3,3,0,0,0,3],
    'panama-la-esmeralda-geisha': [5,1,2,1,2,1,2]
  };
  const valid = p => p && Array.isArray(p.structure) && p.structure.length === 5 && p.structure.every(v => Number.isFinite(v) && v >= 1 && v <= 5) && Number.isInteger(p.flavor_preference) && p.flavor_preference >= 0 && p.flavor_preference < 4;
  const typeFlavors=[[5,0,0,0,0,0,0],[0,5,5,0,0,0,0],[0,0,0,5,5,0,0],[0,0,0,0,0,0,5]];
  const typePriority=['dreamer','explorer','adventurer','gourmand','purist','connoisseur','minimalist','harmonist'];
  function tasteType(user) {
    if(!valid(user))return null;
    const v=user.structure,[C,A,S,M,F]=v.map(n=>n/5),[FT,CI,SF,BE,TG,FW,SC]=typeFlavors[user.flavor_preference].map(n=>n/5);
    const range=Math.max(...v)-Math.min(...v),mean=v.reduce((a,b)=>a+b,0)/5;
    const scores={dreamer:100*(.45*FT+.35*C+.2*F),explorer:100*(.45*Math.max(SF,CI)+.3*A+.25*C),adventurer:100*(.45*Math.max(BE,TG,FW)+.35*F+.2*A),gourmand:100*(.45*SC+.35*S+.2*M),purist:100*(.5*C+.3*F+.2*(6-v[1])/5),connoisseur:100*(.4*M+.35*F+.25*S),minimalist:100*(.5*C+.3*(6-v[3])/5+.2*(6-v[1])/5),harmonist:100*(.75*(1-range/4)+.25*mean/5)};
    const available=typePriority.slice(0,6),order=[];
    while(available.length){const max=Math.max(...available.map(id=>scores[id]));const id=typePriority.find(id=>available.includes(id)&&max-scores[id]<=.01+1e-12);order.push(id);available.splice(available.indexOf(id),1);}
    const primary=v[0]===5&&v[3]<=2&&v[1]<=3?'minimalist':range<=1&&mean>=4?'harmonist':order[0];
    return {taste_type:primary,secondary_taste_type:order.find(id=>id!==primary),taste_type_scores:scores};
  }
  function profile(answers) {
    const structure = initial[answers[0]].slice();
    structure[1] = Math.max(1,Math.min(5,structure[1]+[-1,0,1][answers[1]]));
    structure[3] = Math.max(1,Math.min(5,structure[3]+[-1,0,1][answers[2]]));
    const user={version:1, structure, flavor_preference:answers[3], diagnosed_at:new Date().toISOString()};
    return {...user,...tasteType(user)};
  }
  function match(user, product) {
    if (!valid(user) || structurePending.includes(product.handle) || !Array.isArray(product.structure) || product.structure.length !== 5 || !product.structure.every(v => Number.isFinite(v) && v >= 1 && v <= 5) || !flavors[product.handle]) return null;
    const distance = user.structure.reduce((s,v,i) => s + Math.abs(v-product.structure[i])*weights[i],0) / weights.reduce((s,v)=>s+v,0);
    const structure = Math.max(0,Math.min(100,100*(1-distance/4)));
    const family = flavorWeights[user.flavor_preference];
    const flavor = user.flavor_preference === 1
      ? Math.max(Math.pow(flavors[product.handle][1]/5,1.5)*100,Math.pow(flavors[product.handle][2]/5,1.5)*100)
      : family.reduce((s,w,i)=>s+w*Math.pow(flavors[product.handle][i]/5,1.5)*100,0) / family.reduce((s,w)=>s+w,0);
    return Math.round(Math.max(0,Math.min(100,structure*.6+flavor*.4)));
  }
  function bonus(product, mood) {
    const value = product.structure[mood === 0 ? 0 : mood === 1 ? 2 : 4];
    if (mood === 2) {
      const flavor = flavors[product.handle] || [];
      return (value === 5 ? 1 : value === 4 ? .5 : 0)
        + (flavor.includes(5) ? 1.5 : 0)
        + (flavor.filter(v=>v>=4).length>=2 ? .5 : 0);
    }
    return value === 5 ? 5 : value === 4 ? 3 : value === 3 ? 1 : 0;
    // The additional distinctive +2 is withheld until its product list is approved.
  }
  const model = {profile, match, bonus, flavors, valid, structurePending, tasteType};
  if (typeof module !== 'undefined' && module.exports) module.exports = model;
  else root.CoffeeProfileModel = model;
})(typeof window !== 'undefined' ? window : globalThis);
